<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new"
            :bigTotal="bigTotal"
            :back-button="true"
            :loading="loading" :total="bigTotal"
            :label="'Utilisateur'">
      <router-link :to="{name: 'UserCreate'}" class="dropdown-item" slot="dropdown-content" v-if="isAdmin || isSectorManager">
        <span class="icon"><i class="fas fa-plus-circle"></i></span>
        <span>Créer utilisateur</span>
      </router-link>
      <a v-if="['operator'].includes(currentUserProfil) || isAdmin"
        href="#"
        @click="() => {
          let params = {
            mode: 'append'
          }
          if (this.isOperator) {
            params.facets = {
              'USER': ['is_external:False']
            }
          }
          this.$store.commit('setQuickview', {mode: 'NEW_EVENT', params: params})
        }" 
        :to="{name: 'UserCreate'}" class="dropdown-item" slot="dropdown-content" >
        <span class="icon"><i class="fas fa-plus-circle"></i></span>
        <span>Créer une annonce</span>
      </a>
      <router-link :to="{name: 'PoleList'}" class="dropdown-item" slot="dropdown-content" v-if="isAdmin">
        <span>Afficher Pôles</span>
      </router-link>
      <router-link :to="{name: 'CompanyList'}" class="dropdown-item" slot="dropdown-content" v-if="isAdmin || isSectorManager">
        <span>Afficher Sociétés</span>
      </router-link>
      <router-link :to="{name: 'ExternalAccessList'}" class="dropdown-item" slot="dropdown-content" v-if="isAdmin">
        <span>Accès externes</span>
      </router-link>
      <a @click="exportXls('users-export', query)" class="dropdown-item" slot="dropdown-content" v-if="isAdmin || isSectorManager">
        <span class="icon"><i class="fas fa-file-export"></i></span>
        <span>Exporter données .XLS</span>
      </a>
      <a @click="loadItems()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-sync"></i></span>
        <span>Actualiser données</span>
      </a>
    </sticky>
    <spinner-round :isLoading="loading" v-if="loading"></spinner-round>
    <div class="page-content columns collapseColumn collapseColumn--left collapseColumn--alignStart"
         id="columns-collapse"
         :class="opened ? 'is-active-collapse' : 'is-inactive-collapse'">
      <div class="column is-4 is-3-widescreen is-3-fullhd">
        <list-filter @resetFilters="resetFilters"
                     @changeFilters="changeFilters"
                     :total="total"
                     :bigTotal="bigTotal"
                     :loading="loading"
                     :hasFilter="hasFilter"
                     @opened="opened = !opened">
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <input @input="updateFilters" v-model="filters.last_name" class="input" type="text"
                        placeholder="Nom / Prénom">
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <input @input="updateFilters" v-model="filters.email" class="input" type="text"
                        placeholder="Email">
              </div>
            </div>
          </div>
          <div class="columns" v-if="!isExternal">
            <div class="column is-paddingless-bottom is-padding-top-small">
              <div class="control">
                <multiselect @select="updateCompanyFilter" @remove="updateCompanyFilter(null)"
                             v-model="filters.company" label="name" track-by="pk"
                             :options="companies" :searchable="true"  :show-labels="false"
                             class="multiselect--option-ico is-single_choice"
                             @search-change="getCompanies" :placeholder="''">
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="companies.length"
                         @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oups! Aucune société trouvée.</span>
                  <span slot="noOptions">La liste est vide</span>
                  <span slot="singleLabel" class="multiselect__placeholder">Société</span>
                  <span slot="placeholder" class="multiselect__placeholder">Société</span>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="columns" v-if="!isSeller && !isManager && !isExternal">
            <div class="column is-padding-top-small">
              <label class="label">Profils</label>
              <div class="columns is-gapless is-multiline">
                <div class="column is-margin-top-small is-12" v-for="p in profilsByProfil" :key="p.pk">
                  <div class="field">
                    <input class="is-checkradio" :id="p.pk" type="checkbox" name="profil" :value="p.pk"
                           @click="updateFilters"
                           v-model="filters.profil">
                    <label :for="p.pk">{{ p.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </list-filter>
      </div>
      <div class="column is-8 is-9-widescreen is-9-fullhd is-overflow-auto">
        <div class="is-border">
          <div class="columns is-gapless row-width-actions-bar is-border-bottom">
            <transition enter-active-class="animated fadeIn faster" leave-active-class="animated fadeOut faster" mode="out-in">
              <div class="column is-narrow has-bg-primary columns is-vcentered is-gapless" v-if="hasFilter && !loading && total !== bigTotal">
                <div class="column is-padding-left is-padding-right has-text-white">Résultat : {{total || 0}} utilisateur(s)</div>
              </div>
            </transition>
            <div class="column"></div>
            <div class="column is-narrow">
              <button class="page-header-btn is-square is-static is-ghost">
                <span class="icon"><i class="fas fa-sort-amount-upXX"></i></span>
              </button>
            </div>
          </div>
          <div class="column is-narrow is-padding-top-small is-padding-bottom-small is-border-bottom" v-if="isAdmin || isManager || isSectorManager">
            <label class="checkbox checkRadioIsHide is-padding-right-xsmall" :for="s.value" v-for="s in activationStatus" :key="s.value">
              <input type="checkbox" :id="s.value" @click="updateDisabledFilter(s)" :value="s.value">
              <span class="tag" :class="s.color">
                <span>{{s.label}}</span>
                <span class="icon">
                  <i class="far" :class="filters.disabled === s.value ? 'fa-check-square' : 'fa-square'"></i>
                </span>
              </span>
            </label>
          </div>
          <div class="is-padding is-border-bottom" v-if="hasFilter">
            <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
            <div class="tags">
              <span class="tag is-primary is-rounded" v-if="filters.last_name">
                {{filters.last_name}} <a @click="deleteFilterAlone('last_name')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.email">
                {{filters.email}} <a @click="deleteFilterAlone('email')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.company">
                {{filters.company.name}} <a @click="updateCompanyFilter(null)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-primary is-rounded" v-if="filters.profil"
                    v-for="(profil, i) in filters.profil" :key="'profil-' + i">
                {{profils.find(x => x.pk === profil).name}} <a @click="deleteFilter(i, 'profil')" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
              </span>
              <span class="tag is-annonce is-rounded has-cursor-pointer" @click="resetFilters">
                Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i class="fas fa-undo"></i></span>
              </span>
            </div>
          </div>
          <table-h-scroll :has-sticky="true" :sticky-styles="stickyStyles"
                          :sticky-datas="stickyDatas" :reload-controls="loading && items.length">
            <table v-show="!loading && items.length"
                   class="table is-fullwidth is-narrow is-striped-v is-first-fixed-small is-last-fixed-small is-marginless-bottom has-actionsontd">
              <thead>
              <tr class="is-size-6">
                <th class="is-paddingless has-text-centered actions" style="z-index:2;">
                  <div class="dropdown is-hoverable is-left">
                    <div class="dropdown-trigger">
                      <button class="button is-circle is-small" aria-haspopup="true" aria-controls="dropdown-menu">
                        <i class="fal fa-cog"></i>
                      </button>
                    </div>
                    <columns-toggles :entries="columnsList" :source="columns" @update="updateColumns"></columns-toggles>
                  </div>
                </th>
                <th v-if="showColumn('picture')"></th>
                <th>
                  <sortable @sort="sort('last_name', $event)" :sort="sortBy.last_name" label="Nom"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('first_name', $event)" :sort="sortBy.first_name" label="Prénom"></sortable>
                </th>
                <th v-if="isAdmin || isSectorManager">
                  <sortable @sort="sort('company_name', $event)" :sort="sortBy.company_name" label="Société"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('profil_type', $event)" :sort="sortBy.profil" label="Profil"></sortable>
                </th>
                <th>
                  <sortable @sort="sort('email', $event)" :sort="sortBy.email" label="Email"></sortable>
                </th>
                <th v-if="showColumn('phone')">Téléphone</th>
                <th v-if="showColumn('address')">Adresse</th>
                <th v-if="showColumn('admin_ref') && (isAdmin || isSectorManager)">
                  <sortable @sort="sort('referent_name', $event)" :sort="sortBy.referent_name" label="Admin référent"></sortable>
                </th>
                <th v-if="showColumn('rem') && (isAdmin || isSectorManager)">
                  <sortable @sort="sort('can_display_remuneration', $event)" :sort="sortBy.can_display_remuneration" label="Voit sa rém."></sortable>
                </th>
                <th class="has-text-centered"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(user, i) in items" :key="user.pk" class="is-size-6"  :id="'e' + user.pk" :class="{'has-status-bar--left has-status-bar--draft':scrollToEl === user.pk}">
                <td  class="has-text-centered">
                  <span v-if="isAdmin || isManager || isSectorManager" class="dot tooltip is-tooltip-right" :class="user.disabled ? 'has-bg-danger' : 'has-bg-success'" :data-tooltip="user.disabled ? 'Désactivé' : 'Actif'"></span>
                  <span v-else></span>
                </td>
                <td class="is-cell-hoverable" v-if="showColumn('picture')">
                  <router-link :to="{name: 'UserVue', params: {id: user.pk}, query: {returnId: user.pk}}">
                    <avatar :item="user" :i="i"></avatar>
                  </router-link>
                </td>
                <td class="is-cell-hoverable">
                  <router-link :to="{name: 'UserVue', params: {id: user.pk}, query: {returnId: user.pk}}" class="fullLink">
                    <span> {{user.last_name}} </span>
                  </router-link>
                </td>
                <td class="is-cell-hoverable">
                  <router-link :to="{name: 'UserVue', params: {id: user.pk}, query: {returnId: user.pk}}" class="fullLink">
                    <span> {{user.first_name}} </span>
                  </router-link>
                </td>
                <td v-if="isAdmin || isSectorManager" :class="{'is-cell-hoverable': user.company}">
                  <router-link :to="{name: 'CompanyVue', params: {id: user.company}, query: {returnId: user.pk}}" v-if="user.company"
                               class="fullLink" :title="user.company_name">
                    {{user.company_name | truncate}}
                  </router-link>
                  <span v-else>-</span>
                </td>
                <td>{{user.profil_type | profilTypeLabel}}</td>
                <td class="is-cell-hoverable">
                  <router-link :to="{name: 'UserVue', params: {id: user.pk}, query: {returnId: user.pk}}"
                    :title="user.email"
                  >
                    {{user.email || '-' | truncate(33)}}
                  </router-link>
                </td>
                <td v-if="showColumn('phone')">{{user.phone || '-'}}
                </td>
                <td v-if="showColumn('address')">
                  {{user.address.city || '-'}} <span v-if="user.address.zip_code">({{user.address.zip_code}})</span>
                </td>
                <td v-if="showColumn('admin_ref') && (isAdmin || isSectorManager)">
                  <span v-if="user.is_admin">-</span>
                  <span v-else-if="user.referent_name">{{user.referent_name}}</span>
                  <span v-else>NC</span>
                </td>
                <td v-if="showColumn('rem') && (isAdmin || isSectorManager)">
                  <span>{{user.can_display_remuneration ? 'Oui' : 'Non'}}</span>
                </td>
                <td class="has-text-centered actions">
                  <display-button-list :buttons="buttonList" :data="user"
                    :openUp="{'position': i, 'total': items.length}">
                  </display-button-list>
                </td>
              </tr>
              <tr class="empty empty--row" v-for="n in items.length < 4 ? 4 - items.length : 0 " :key="n"><td class="is-borderless"></td></tr>
              </tbody>
            </table>
          </table-h-scroll>
          <div class="is-border-top" v-if="totalPage > 1 && nextPage && !loading">
            <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
              <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
              <span class="is-size-6">Afficher la suite</span>
            </a>
            <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
          </div>
          <div v-show="!loading && !items.length">
            <div class="columns">
              <div class="column">
                <h2 class="title is-3 has-text-weight-bold">Aucun utilisateur disponible</h2>
                <a class="has-text-primary" @click="resetFilters" v-if="hasFilter"><span class="icon is-small"><i
                  class="fal fa-undo-alt"></i></span> <span>Réinitialiser les filtres</span></a>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="columns is-gapless is-padding-left is-padding-right is-vcentered" v-if="!loading">
          <div class="column">
            <pagination :loading="loading" @ChangePage="currentPage = $event" :currentPage="currentPage"
                        :totalPage="totalPage" :reverse="true"></pagination>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import { GenericList, Sort, Filter, DefaultValues, Error, ColumnConf, TableHeaderSticky } from '../../mixins'
  import { mapGetters, mapState } from 'vuex'
  import { exportXls } from '../../utils'
  import { debounce, isPlainObject } from 'lodash'

  export default {
    name: 'UserList',
    mixins: [GenericList, Sort, Filter, DefaultValues, Error, ColumnConf, TableHeaderSticky],
    data () {
      return {
        opened: true,
        buttonList: [
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'UserVue', params: {id: actionId}, query: {returnId: actionId}})
            },
            icon: 'fas fa-address-card',
            text: 'Fiche utilisateur'
          },
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'UserEdit', params: {id: actionId}, query: {returnId: actionId}})
            },
            icon: 'fas fa-user-edit',
            text: 'Modifier fiche utilisateur',
            needProfile: ['admin', 'manager', 'manager_ext', 'sector_manager']
          },
          {
            display: (user) => {
              return !user.last_login_at
            },
            action: (id, user) => {
              this.inviteUser(user.email)
            },
            icon: 'fas fa-paper-plane',
            text: 'Envoyer invitation',
            needProfile: ['admin', 'manager', 'manager_ext', 'sector_manager']
          },
          {
            display: (data) => {
              return !data.disabled && data.pk !== this.currentUserPk
            },
            action: (id, user) => {
              let data = {disabled: !user.disabled}
              this.disableUser(id, data)
            },
            icon: 'fas fa-minus-circle',
            text: 'Désactiver utilisateur',
            needProfile: ['admin', 'manager', 'manager_ext', 'sector_manager']
          },
          {
            display: (data) => {
              return data.disabled && data.pk !== this.currentUserPk
            },
            action: (id, user) => {
              let data = {disabled: !user.disabled}
              this.disableUser(id, data)
            },
            icon: 'fas fa-check-circle',
            text: 'Activer utilisateur',
            needProfile: ['admin', 'manager', 'manager_ext', 'sector_manager']
          }
        ],
        loadDocuments: this.loadItems,
        service: this.$api.userService,
        exportXls,
        filters: {
          profil: []
        },
        initFilters: {
          profil: []
        },
        companies: [],
        columnsConfResource: 'users',
        activationStatus: [
          {value: 'active', label: 'Actif', color: 'is-success'},
          {value: 'inactive', label: 'Désactivé', color: 'is-danger'}
        ],
        infiniteLoaderEnabled: true
      }
    },
    computed: {
      ...mapState({
        scrollToEl: 'scrollToEl',
        companiesList: 'companies'
      }),
      ...mapGetters(['isAdmin', 'isSuperAdmin', 'isSeller', 'isExternal', 'isManager', 'isSectorManager', 'isOperator', 'currentUserPk', 'currentUserProfil']),
      columnsShow () {
        let columns = {
          'phone': {label: 'Téléphone', mobile: false},
          'address': {label: 'Adresse', mobile: false}
        }
        if (this.isAdmin || this.isSectorManager) {
          columns['rem'] = {label: 'Voit sa rém.', mobile: false}
          columns['admin_ref'] = {label: 'Admin référent', mobile: false}
        }
        return columns
      },
      profilsByProfil () {
        if (this.isSectorManager) {
          let managerExtOkStatus = ['seller_ext', 'manager_ext']
          return this.profils.filter(x => {
            if (managerExtOkStatus.includes(x.type)) return x
          })
        } else {
          return this.profils
        }
      }
    },
    methods: {
      deleteFilterAlone (val) {
        this.$set(this.filters, val, null)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      inviteUser (email) {
        this.$api.userService.invite({email: email}, this.$configs.APPHOST).then(() => {
          this.$notify({
            type: 'is-success',
            text: `Un mail d'activation à été envoyé à l'adresse ${email}`
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: `Erreur lors de l'envoi d'un mail d'activation à l'adresse ${email}`
          })
        })
      },
      updateCompanyFilter (e) {
        this.$set(this.filters, 'company', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      getCompanies () {
        this.$api.companyService.get().then(r => {
          this.companies = r.data.items
        })
      },
      errorDelete (r) {
        this.handleError(r)
      },
      beforeGet () {
        if (!this.query.company) {
          this.query.company = undefined
        }
        if (this.query.company && isPlainObject(this.query.company)) {
          this.query.company = this.query.company.pk
        }
        if (this.query.disabled === null) {
          this.query.disabled = undefined
        }
        if (this.query.disabled === 'active' || this.query.disabled === 'inactive') {
          this.query.disabled = this.query.disabled === 'active' ? 0 : 1
        }
        if (typeof this.query.profil === 'string') {
          this.query.profil = [this.query.profil]
        }
      },
      updateDisabledFilter (e) {
        this.$set(this.filters, 'disabled', e.value)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateFilters: debounce(function () {
        this.changeFilters()
      }, 300),
      disableUser (id, data) {
        this.$api.userService.patch(id, data).then((res) => {
          this.$notify({
            type: `is-${data.disabled ? 'warning' : 'success'}`,
            text: `Utilisateur ${data.disabled ? 'désactivé' : 'activé'}`
          })
          let idx = this.items.findIndex(x => x.pk === res.data.pk)
          if (idx >= 0) {
            this.items.splice(idx, 1, res.data)
          }
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: `Impossible ${data.disabled ? 'de désactiver' : 'd\'activer'} cet utilisateur.`
          })
        })
      },
      deleteFilter (i, key) {
        this.filters[key].splice(i, 1)
        this.$nextTick(() => {
          this.changeFilters()
        })
      }
    },
    created () {
      if (typeof this.filters.profil === 'string') {
        this.filters.profil = [this.filters.profil]
      }
      if (this.query.disabled === 1 || this.query.disabled === '1') {
        this.filters.disabled = 'inactive'
      }

      if (this.query.disabled === 0 || this.query.disabled === '0') {
        this.filters.disabled = 'active'
      }
      this.companies = this.companiesList.slice()
      this.changeFilters()
    }
  }
</script>

<style>
.is-annonce {
  background-color: #f87051
}
</style>



// WEBPACK FOOTER //
// src/components/users/UserList.vue